module.exports = __webpack_public_path__ + "static/media/warnig-user.67abcca5.svg";